<template>
  <div id="tabs">
    <button
      @click="selectTab(tabData.id)"
      v-for="(tabData, index) in content"
      v-bind:key="tabData.id"
      v-bind:class="{
      'tab-button tab-button-override active active_tab_class': (currentTab === tabData.id),
      'tab-button tab-button-override inactive': (currentTab != tabData.id) ,
      'custom-shadow': (index === content.length - 1)
      }"
    >{{tabData.title}}</button>
    <div class="noselect doc-viewer">
      <div class="wrapper-div">
        <template v-for="tabData in content">
          <div v-if="currentTab === tabData.id" :key="tabData.id">
            <div class="pdf-div" v-if="displayPdf&&sasToken">
              <PDFViewer :url="tabData.content+sasToken" @document-errored="documentErrored"></PDFViewer>
            </div>
            <h3 v-else>File Not present</h3>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import getSasToken from '../../apis/sasToken';
import PDFViewer from '../PDFViewer/PDFViewer.vue';

export default {
  props: {
    content: Array,
    noOfTabs: Number,
    roleId: Number,
    country: String,
    userId: Number,
  },
  components: {
    PDFViewer,
  },
  async created() {
    await this.getSasToken();
  },
  data() {
    return {
      currentTab: 1,
      errorFileMessage: false,
      newFile: '',
      errorTxt: '',
      activeTab: 1,
      prevFile: '',
      selectedTab: '',
      sasToken: '',
      displayPdf: true,
    };
  },
  watch: {
    content() {
      this.displayPdf = true;
    },
  },
  methods: {
    selectTab(selectedTab) {
      this.displayPdf = true;
      this.currentTab = selectedTab;
    },
    /**
     * getSasToken()
     * Sas token API call.
     */
    async getSasToken() {
      this.$emit('changeLoaderStatus', true);
      const sasTOkenData = {
        container_name: process.env.VUE_APP_REGINTELL_CONTAINER_NAME,
        file_name: '',
        folder_name: '',
        permissions: 'read',
        storage_name: 'rams-storage-java',
      };
      this.sasToken = await getSasToken(sasTOkenData);
      this.displayPdf = true;
      this.$emit('changeLoaderStatus', false);
    },
    documentErrored() {
      this.displayPdf = false;
    },
  },
};
</script>
<style scoped>
.download_content {
  padding-left: 7px;
}
.download_content,
.download_option {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #0b3c61;
}
.FT_right {
  text-align: right;
}
.file_upload_container {
  position: relative;
}
.PDL_10 {
  padding-left: 10px;
}
.file_upload_container a + input {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  cursor: pointer;
}
.active_tab_class {
  color: #0b3c61;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  -o-user-select: none;
}

.tab-content {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}

.tab-button {
  width: 32%;
  word-break: break-all;
  height: 60px;
  padding: 8px;
  border-radius: 10px 10px 0 0;
  outline: none;
  border: none;
  border-bottom-color: #fff;
  vertical-align: middle;
  opacity: 1;
  font-size: 16px;
  font-weight: bold;
  font-family: Roboto;
  font-style: normal;
  line-height: 20px;
  -moz-box-shadow: -3px -2px 7px 0 rgba(0, 0, 0, 0.1) !important;
  -webkit-box-shadow: -3px -2px 7px 0 rgba(0, 0, 0, 0.1) !important;
  box-shadow: -3px -2px 7px 0 rgba(0, 0, 0, 0.1) !important;
}

@media (min-width: 551px) and (max-width: 800px) {
  .tab-button {
    height: 80px;
  }
}
@media screen and (max-width: 550px) {
  .tab-button {
    height: 130px;
  }
}
@media (min-width: 1024px) and (max-width: 1034px) {
  .tab-button {
    height: 68px;
  }
}

@media (max-width: 1400px) {
  ::v-deep .custom_tabs .el-tabs--card > .el-tabs__header .el-tabs__item {
    width: 27rem !important;
    padding: 15px 10px;
    font-size: 14px !important;
  }
}

.active {
  background: #ffffff;
}

.inactive {
  background: #0b3c61;
  opacity: 0.3;
  color: #ffffff;
}
.doc-viewer {
  background: #ffffff;
  margin-bottom: 10px;
  -moz-border-radius: 0px 0px 12px 12px;
  -webkit-border-radius: 0px 0px 12px 12px;
  border-radius: 0px 12px 12px 12px;
  -moz-box-shadow: -2px 1px 7px rgba(0, 0, 0, 0.25);
  -webkit-box-shadow: -2px 1px 7px rgba(0, 0, 0, 0.25);
  box-shadow: -2px 1px 7px rgba(0, 0, 0, 0.25);
}
.padding-bottom-10 {
  padding-bottom: 10px;
}
.pdf-div {
  box-shadow: 2px 4px 20px rgba(0, 0, 0, 0.25);
  border: 4px;
}
.wrapper-div {
  padding: 20px;
}
.pdf-viewer {
  height: 700px;
  overflow-x: auto;
  box-shadow: 2px 4px 20px rgba(0, 0, 0, 0.25);
}
.custom-shadow.active{
  box-shadow: 2px -2px 7px 0 rgba(0,0,0,.1)!important;
}

</style>
